function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27 27",
    width: "27px",
    height: "27px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface175207107"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,16.470589%,61.56863%)",
      fillOpacity: 1
    },
    d: "M 13.5 2.699219 C 7.535156 2.699219 2.699219 7.535156 2.699219 13.5 C 2.699219 18.914062 6.6875 23.386719 11.886719 24.167969 L 11.886719 16.363281 L 9.214844 16.363281 L 9.214844 13.523438 L 11.886719 13.523438 L 11.886719 11.632812 C 11.886719 8.507812 13.410156 7.132812 16.007812 7.132812 C 17.253906 7.132812 17.910156 7.226562 18.222656 7.269531 L 18.222656 9.746094 L 16.449219 9.746094 C 15.347656 9.746094 14.960938 10.792969 14.960938 11.972656 L 14.960938 13.523438 L 18.195312 13.523438 L 17.757812 16.363281 L 14.960938 16.363281 L 14.960938 24.1875 C 20.234375 23.476562 24.300781 18.96875 24.300781 13.5 C 24.300781 7.535156 19.464844 2.699219 13.5 2.699219 Z M 13.5 2.699219 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d1f13799abe3c079218d0afa0b50f871.svg";
export { ForwardRef as ReactComponent };